export default [
    {
        // [0]
        key: "ip",
        label: "IP",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [1]
        key: "start_session",
        label: "start session",
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [2]
        key: "end_session",
        label: "end session",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
]